const vWcCheckout = () => {
	const checkout = document.querySelector('form.woocommerce-checkout.v-woocommerce-form');
	if(checkout) {

		/* Billing: Show save billing address as default checkbox if different */
		const billingCheckboxWrapper = document.querySelector('#save_billing_address_field');
		const billingInput = document.querySelector('input[name="billing_address_1"]');
		const defaultBilling = document.querySelector('input[name="user_default_billing_address"]');
		const isAddressSame = (address1, address2) => address1 !== address2;

		if(billingCheckboxWrapper) {
			const billingInputEventHandler = () => {
			const wrapperClass = billingCheckboxWrapper.classList;
			if(isAddressSame(defaultBilling.value, billingInput.value)) {
				wrapperClass.remove('hide-wrapper');
			} else {
				wrapperClass.add('hide-wrapper');
			}
			};
			billingInputEventHandler();
			billingInput.addEventListener('input', billingInputEventHandler);

			// /* Make sure clicking pca suggestion change is caught */
			const observer = new MutationObserver(billingInputEventHandler);
			observer.observe(billingInput, { attributes: true, childList: true, subtree: true, characterData: true });

			/* Shipping: Show save shipping address as default checkbox if different */
			const shippingCheckboxWrapper = document.querySelector('.woocommerce-form__label--save-shipping-address');
			const shippingInput = document.querySelector('input[name="shipping_address_1"]');
			const defaultShipping = document.querySelector('input[name="user_default_shipping_address"]');
			shippingInput.addEventListener('input', () => {
				if(defaultShipping.value !== shippingInput.value) {
					shippingCheckboxWrapper.classList.remove('hidden');
				} else {
					shippingCheckboxWrapper.classList.add('hidden');
				}
			});

			/* Make sure clicking pca suggestion change is caught */
			const shippingObserver = new MutationObserver(() => {
				if(defaultShipping.value !== shippingInput.value) {
					shippingCheckboxWrapper.classList.remove('hidden');
				} else {
					shippingCheckboxWrapper.classList.add('hidden');
				}
			});
			shippingObserver.observe(shippingInput, { attributes: true, childList: true, subtree: true, characterData: true });
		}

		/** Trigger checkout reload after clicking selecting a shipping type */
		const shippingTypesInit = () => {
			const shipToDifferentAddressInput = document.querySelector('#ship-to-different-address-checkbox')
			const shippingTypeInputs = document.querySelectorAll('.customer-shipping-types input[type="radio"]');
			if(shippingTypeInputs.length) {
				shippingTypeInputs.forEach(input => {
					input.addEventListener('click', (e) => {
						if(e.target.value === 'ship_to_different_address') {
							shipToDifferentAddressInput.click();
						}

						if(
							e.target.value !== 'ship_to_different_address'
							&& shipToDifferentAddressInput.checked === true
						) {
							shipToDifferentAddressInput.click();
						}

						window.jQuery(document.body).trigger('update_checkout');
					});
				});
			}
		};

		// Scroll to center of page after form submission
		window.jQuery('form.checkout').on('submit', () => {
			const noticeElm = document.querySelector('.v-woocommerce-checkout-notice');
			const main = document.querySelector('.v-main');
			if(noticeElm) {
				noticeElm.classList.remove('v-woocommerce-checkout-notice--hide');
			} else {
				const submissionNotice = document.createElement('p');
				submissionNotice.textContent = 'Every great venture takes time! Please don’t close this window while we finalize your order.';
				submissionNotice.classList.add('v-woocommerce-checkout-notice');
				main.appendChild(submissionNotice);
			}

			window.scrollTo({
				top: (document.body.scrollHeight - window.innerHeight) / 2,
				behavior: 'smooth'
			});
		});

		// VersaPay Plugin Repair: Button becomes unresponsive after validation error so we need to show the user they need to change something
		window.jQuery('body').on('checkout_error', () => {
			setTimeout(() => {
				const selectedPayment = window.jQuery('input[name="payment_method"]:checked').val();
				if (selectedPayment === 'versapay') {
					window.jQuery(document.body).trigger('updated_checkout');
				}
			}, 1000);
			const submissionNoticeElm = document.querySelector('.v-woocommerce-checkout-notice');
			if(submissionNoticeElm) {
				submissionNoticeElm.classList.add('v-woocommerce-checkout-notice--hide');
			}
		});

		// Customize checkout fields with required labels because it can't be done via PHP
		const modifyCheckoutFields = () => {
			const fieldLabels = document.querySelectorAll('.form-row abbr.required');
			if(fieldLabels.length) {
				fieldLabels.forEach(field => {
					const fNode = field;
					fNode.textContent = '';
				});
			}
		};

		window.jQuery(document.body).on('init_checkout', () => {
			modifyCheckoutFields();
		});

		window.jQuery(document.body).on('country_to_state_changed', () => {
			setTimeout(() => {
				modifyCheckoutFields();
			}, 100);
		});

		// Add confirmation message coupon code
		window.jQuery(document.body).on('updated_checkout', () => {
			const couponNotice = window.jQuery('.woocommerce-message:contains("code applied successfully")');
			if (couponNotice.length) {
				const couponMessage = window.jQuery('.coupon-message');
				couponMessage.text('Coupon code applied succesfully.');
				couponMessage.show();
				setTimeout(() => {
					couponMessage.hide();
				}, 5000);
			}

			modifyCheckoutFields();
		});

		// Only allow numeric characters on phone inputs
		const phoneInputs = checkout.querySelectorAll('input[type="tel"]');
		if(phoneInputs.length) {
			phoneInputs.forEach(input => {
				input.addEventListener('keypress', (e) => {
					if (!/[0-9]/.test(e.key)) {
						e.preventDefault();
					}
				});
			});
		}

		shippingTypesInit();
	}
}

export default vWcCheckout;
